<div class="container" data-aos="fade-down" data-aos-duration="1500" [ngStyle]="!isDarkTheme ?{'color':'#212529'} : {'color': '#ffffff'}">
    <div class="updates">
        <div class="heading">
            <span>LATEST</span>
        </div>
        <div class="sub-heading">
            <span class="news_title">Black Lotus Labs At Work</span>
        </div>
        <div class="container-1">
            <div class="img-1"></div>
            <div class="content-one" [ngStyle]="isDarkTheme ?{'background':'#212529'} : {'background': '#ffffff'}">
                <p class="heading">Lumen Unveils 2026 Defender Threatscape Report: Upstream Network Visibility is the New Front Line of Cyber Defense</p>
                <p>Black Lotus Labs reveals why upstream network visibility is essential to detecting and disrupting disguised proxies, edge exposure, and AI-driven attacks.</p>
                <button class="chi-button"
                        (click)="openExternalLink('https://ir.lumen.com/news/news-details/2026/Lumen-Unveils-2026-Defender-Threatscape-Report-Upstream-Network-Visibility-is-the-New-Front-Line-of-Cyber-Defense/default.aspx')">
                    Learn More
                </button>
            </div>
        </div>
        <div class="container-1">
            <div class="img-2"></div>
            <div class="content-one" [ngStyle]="isDarkTheme ?{'background':'#212529'} : {'background': '#ffffff'}">
                <p class="heading">Lumen Extends Black Lotus Labs Threat Intelligence to AWS Network Firewall, Delivering Proactive Protection</p>
                <p>By extending Black Lotus Labs’ upstream threat intelligence into AWS Network Firewall, enterprises can detect and block threats before they cause harm and without adding infrastructure or complexity.</p>
                <button class="chi-button"
                        (click)="openExternalLink('https://ir.lumen.com/news/news-details/2025/Lumen-Extends-Black-Lotus-Labs-Threat-Intelligence-to-AWS-Network-Firewall-Delivering-Proactive-Protection/default.aspx')">
                    Learn More
                </button>
            </div>
        </div>
        <div class="container-1">
            <div class="img-3"></div>
            <div class="content-one" [ngStyle]="isDarkTheme ?{'background':'#212529'} : {'background': '#ffffff'}">
                <p class="heading">Lumen Launches Defender Advanced Managed Detection and Response for Microsoft Customers</p>
                <p>Lumen’s newest collaboration brings managed security expertise to Microsoft Sentinel to transform operations with network-driven intelligence from Black Lotus Labs.</p>
                <button class="chi-button"
                        (click)="openExternalLink('https://ir.lumen.com/news/news-details/2025/Lumen-Launches-Defender-Advanced-Managed-Detection-and-Response-for-Microsoft-Customers/default.aspx')">
                    Learn More
                </button>
            </div>
        </div>
        <div class="container-1">
            <div class="img-4"></div>
            <div class="content-one" [ngStyle]="isDarkTheme ?{'background':'#212529'} : {'background': '#ffffff'}">
                <p class="heading">Lumen Technologies expands APAC cybersecurity capabilities in collaboration with Palo Alto Networks</p>
                <p>Customers benefit from continuous threat hunting, tailored playbooks, and asset discovery powered by Lumen’s SOC analysts and Black Lotus Labs.</p>
               <button class="chi-button"
                        (click)="openExternalLink('https://ir.lumen.com/news/news-details/2025/Lumen-Technologies-expands-APAC-cybersecurity-capabilities-in-collaboration-with-Palo-Alto-Networks--2025-CS7q8Ldt6S/default.aspx')">
                    Learn More
                </button>
            </div>
        </div>
        <div class="container-1">
            <div class="img-5"></div>
            <div class="content-one" [ngStyle]="isDarkTheme ?{'background':'#212529'} : {'background': '#ffffff'}">
                <p class="heading">Lumen Disrupts Cybercriminals Targeting Home and Office Routers</p>
                <p>Black Lotus Labs reveals how TheMoon malware used end-of-life routers to power a notorious cybercrime service called Faceless, urges consumers to secure devices.</p>
                <button class="chi-button"
                        (click)="openExternalLink('https://ir.lumen.com/news/news-details/2024/Lumen-Disrupts-Cybercriminals-Targeting-Home-and-Office-Routers/default.aspx')">
                    Learn More
                </button>
            </div>
        </div>
        <div class="container-1">
            <div class="img-6"></div>
            <div class="content-one" [ngStyle]="isDarkTheme ?{'background':'#212529'} : {'background': '#ffffff'}">
                <p class="heading">Lumen unveils AI-powered threat defense tool for businesses</p>
                <p>Lumen Defender uses Black Lotus Labs' threat intelligence to proactively stop attacks at the network edge.</p>
                <button class="chi-button"
                        (click)="openExternalLink('https://ir.lumen.com/news/news-details/2024/Lumen-unveils-AI-powered-threat-defense-tool-for-businesses/default.aspx')">
                    Learn More
                </button>
            </div>
        </div>
    </div>

</div>